interface IHandleResponseError {
  timestamp?: string;
  status: number;
  statusText?: string;
  error?: string;
  message?: string;
  path?: string;
}

export const handleResponseError = (error: IHandleResponseError | string) => {
  const responseError = typeof error === 'object' ? error : undefined;

  if (!responseError) {
    return { text: error };
  }
  const { status } = responseError;

  return {
    ...responseError,
    text: `Ошибка ${status}`,
  };
};
